let context: AudioContext | null = null;
let timer: number | null = null;
let enabled = false;

function getContext(): AudioContext | null {
  if (typeof window === "undefined") return null;
  const Ctx = window.AudioContext || (window as typeof window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Ctx) return null;
  context ??= new Ctx();
  return context;
}

function beep(): void {
  const ctx = getContext();
  if (!ctx || !enabled) return;
  const start = ctx.currentTime;
  const oscillator = ctx.createOscillator();
  const gain = ctx.createGain();
  oscillator.type = "sine";
  oscillator.frequency.setValueAtTime(880, start);
  gain.gain.setValueAtTime(0.0001, start);
  gain.gain.exponentialRampToValueAtTime(0.18, start + 0.015);
  gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.22);
  oscillator.connect(gain);
  gain.connect(ctx.destination);
  oscillator.start(start);
  oscillator.stop(start + 0.24);
}

export async function startContinuousSignalBeep(): Promise<void> {
  enabled = true;
  const ctx = getContext();
  if (ctx?.state === "suspended") await ctx.resume();
  if (timer === null) {
    beep();
    timer = window.setInterval(beep, 900);
  }
}

export function stopContinuousSignalBeep(): void {
  enabled = false;
  if (timer !== null) {
    window.clearInterval(timer);
    timer = null;
  }
}

export async function prepareContinuousSignalBeep(): Promise<void> {
  const ctx = getContext();
  if (ctx?.state === "suspended") await ctx.resume();
}
